
import echarts from "echarts";
import { Component, Prop, Vue } from "vue-property-decorator";
import { axios, getConfigs, IRequestConfig } from "@/api/appService";

@Component({ name: "DataReport" })
export default class DataReport extends Vue {
  @Prop({ default: "get" })
  apiMethod!: string;

  @Prop({ required: true })
  apiUrl!: string;

  @Prop({ required: true })
  title!: string;

  @Prop({ default: "year" })
  apiParamNameYear!: string;

  @Prop()
  buildApiParameters!: IBuildApiParameters;

  @Prop({ required: true })
  buildChartOption!: IBuildChartOption;

  // private members
  year: number = 2020;
  elementId: string = "";
  fetchCount: number = 0;
  myChart: any;
  loading: boolean = true;

  created() {
    this.elementId = "echarts-report-" + (Math.random() * 1000000).toFixed(0);
    this.year = new Date().getFullYear();
  }

  mounted() {
    this.fetchData();
  }

  async fetchData() {
    this.fetchCount++;
    this.loading = true;
    await this.createApiRequest().then(res => {
      this.renderEChart(res);
      this.loading = false;
    });
  }

  createApiRequest() {
    return new Promise((resolve, reject) => {
      let url = this.apiUrl;

      const configs: IRequestConfig = getConfigs(
        this.apiMethod,
        "application/json",
        url,
        {}
      );
      const yearOption: any = {};
      yearOption[this.apiParamNameYear] = this.year;
      let apiParameters: any = {};
      if (!!this.buildApiParameters) {
        apiParameters = this.buildApiParameters(this.year);
      }
      configs.params = Object.assign({}, yearOption, apiParameters);
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }

  renderEChart(res: any) {
    if (!this.myChart) {
      //@ts-ignore
      this.myChart = echarts.init(document.getElementById(this.elementId));
    }
    const chartOption = Object.assign(
      {},
      {
        grid: {
          left: "30px",
          right: "0px",
          top: "10px",
          bottom: "30px"
        }
      },
      this.buildChartOption(res)
    );
    this.myChart.setOption(chartOption);
  }

  prevYear() {
    this.year--;
    this.fetchData();
  }
  nextYear() {
    this.year++;
    this.fetchData();
  }
}

export interface IBuildApiParameters {
  (year: number): any;
}

export interface IBuildChartOption {
  (res: any): any;
}
